<template>
  <div class="exhibitonScreen">
    <div class="goldBox">
      <div class="title">{{ $t('homePage.quickFind1') }}</div>
      <div class="search">
        <div class="row1">
          <div class="searchBox">
            <el-input v-model="keyWords" :placeholder="$t('homePage.placeholder2')"></el-input>
          </div>
          <div class="btn">
            <el-button icon="el-icon-search" @click="searchClick()">{{ $t('homePage.search') }}</el-button>
          </div>
        </div>
        <div class="row2">
          <div class="selecTree">
            <div class="inputSelect" @click="openPanel">
              <span v-if="!selectProductType">{{ $t('common.screen1') }}</span>
              <span v-else>{{ selectProductType }}</span>
              <i class="el-icon-arrow-down" v-if="!selectvisible"></i>
              <i class="el-icon-arrow-up" v-else></i>
            </div>
          </div>
          <div class="hall">
            <div class="inputSelect" @click="openHallPanel">
              <span v-if="!hallType">{{ $t('common.screen2') }}</span>
              <span v-else>{{ hallType }}</span>
              <i class="el-icon-arrow-down" v-if="!hallVisible"></i>
              <i class="el-icon-arrow-up" v-else></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="productLists" id="proTypeCard">
      <el-drawer :visible="selectvisible" width="100%" direction="btt" :with-header="false" :before-close="handleClose1">
        <el-tabs tab-position="left">
          <el-tab-pane v-for="(item, index) in screenList.conditons" :key="index" class="tabItem">
            <span slot="label">
              <el-checkbox @change="checkFirst(item)" v-model="item.choose">{{ item.title }}</el-checkbox>
            </span>
            <el-collapse v-model="activeNames" @change="handleChange" accordion>
              <el-collapse-item :name="kk" v-for="(ii, kk) in item.children" :key="kk">
                <template slot="title">
                  <el-checkbox @change="checkSecond(ii, item)" v-model="ii.choose">{{ ii.title }}</el-checkbox>
                </template>
                <el-checkbox @change="checkThird(ii, i, item)" v-model="i.choose" v-for="(i, k) in ii.children" :key="k">{{ i.title }}</el-checkbox>
              </el-collapse-item>
            </el-collapse>
          </el-tab-pane>
        </el-tabs>
        <div class="bottom">
          <div class="btn" @click="submit">{{ $t('common.sure') }}</div>
        </div>
      </el-drawer>
    </div>
    <div class="screenTag">
      <div class="rightTitle" :style="{ display: dynamicTags.length > 0 ? 'block' : 'none' }">
        <!--筛选条件框-->
        <el-row class="selectt">
          <div class="text">{{ $t('common.screenConditions') }}</div>
          <!--tags标签 -->
          <div>
            <el-tag :key="k" v-for="(tag, k) in dynamicTags" closable :disable-transitions="false" @close="handleClose(tag)">
              {{ tag.name }}
            </el-tag>
          </div>
          <!-- 清空按钮 -->
          <div class="clear">
            <el-button icon="el-icon-delete" type="primary" @click="clearTag()">{{ $t('common.clear') }}</el-button>
          </div>
        </el-row>
      </div>
    </div>
    <div class="exhibitionList" id="hallCard">
      <el-drawer :visible="hallVisible" width="100%" direction="btt" :with-header="false" :before-close="handleClose2">
        <div class="screenCondition">
          <ul>
            <li v-for="(i, k) in exhibitionList.conditons" :key="k" style="float: left">
              <el-checkbox @change="checkEx(i)" v-model="i.choose"> {{ i.title }}</el-checkbox>
            </li>
          </ul>
        </div>
        <div class="bottom">
          <div class="btn" @click="submitHall">{{ $t('common.sure') }}</div>
        </div>
      </el-drawer>
    </div>
    <!-- 展商列表内容 -->
    <div class="rightContent" :style="{ marginTop: dynamicTags.length > 0 ? '20px' : '0' }" v-if="returnDate.length > 0">
      <!-- <van-index-bar :index-list="indexList" ref="indexBar" @change="scrollTo"> -->
      <van-index-bar ref="indexBar" @change="scrollTo" @select="scrollTo">
        <div v-for="(item, k) in newArrData" :key="k">
          <van-index-anchor v-if="item.addVanIndex" :index="item.letter.toUpperCase()" />

          <div class="content" @click="goDetail(item.id)">
            <div class="vedio1">
              <div class="titleLogo">
                <img :src="`${item.comCover.substr(0,4) == 'http' ?'':baseUrl}${item.comCover}`" alt="" v-if="item.comCover.includes('/')" />
                <img src="../../../../static/占位-展品-列表.png" alt="" v-else />
              </div>
              <div class="top"></div>
              <div class="main">
                <div class="company">{{ lang == 'zh' ? item.companyNameC : item.companyNameE }}</div>
                <span>{{ $t('exhibition.boothNum') }}</span>
                <div class="number">{{ item.hzBoothList[0].boothNum }}</div>
              </div>
              <div class="fixed">
                <div class="banner-btn">
                  <img src="../../../../static/ico_vedio.png" alt="" />
                </div>
              </div>
            </div>
            <div class="bottom">
              <div class="bottomLeft" @click.stop="consult(item)">
                {{ $t('common.talk') }}
              </div>
              <div class="bottomRight" @click.stop="toggle(item)">
                {{ item.collectStatus ? $t('common.cancel') : $t('common.favorites') }}
              </div>
            </div>
          </div>
        </div>
      </van-index-bar>
      <!-- 筛选提交为空 -->
    </div>
    <div class="boxImg" v-else>
      <img src="../../../../static/empty.png" alt="" />
      <div>{{ $t('exhibition.noexhibition') }}</div>
    </div>
    <div class="pagination">
      <!-- <span>{{ $t('common.pagination', { allNum: allNum }) }}</span> -->
      <el-pagination
        v-if="pageshow"
        class="explore_right_pages"
        layout="prev, pager, next"
        :current-page="currentPage4"
        @current-change="handleCurrentChange"
        :page-size="100"
        :total="allNum"
        :pager-count="5"
      >
      </el-pagination>
    </div>
    <Foot />
    <GoLogin :dialogVisible.sync="dialogVisible" @func="getMsgFormSon" @funcancel="getCancel" />
  </div>
</template>

<script>
import SelectProduct from '../../../../common/mobile/searchProduct.vue';
import { screenList } from '../../../../../Json/screenList.js';
import { screenListEn } from '../../../../../Json/screenListEn.js';
import { getShoucang, mobileExhibits } from '../../../../../api/exhibitor';
import Foot from '../../../../common/mobile/footBottom.vue';
import { forMat } from '../../../../../utils/common';
import * as tools from '../../../../../utils/roulink';
import GoLogin from '../../../../common/mobile/goLogin.vue'; //登录提示框

export default {
  name: '',
  components: { SelectProduct, Foot, GoLogin },
  data() {
    return {
      baseUrl: forMat(),
      holder: '',
      selectProductType: '', //产品类型筛选\
      selectvisible: false, //选择产品弹窗
      keyWords: '',
      hallType: '',
      hallVisible: false,
      screenList: null,
      activeNames: [0],
      dynamicTags: [],
      exhibitionList: {
        title: this.$t('common.screen2'),
        conditons: [
          {
            id: '2-1',
            title: 'E1',
            choose: false,
          },
          {
            id: '2-2',
            title: 'E2',
            choose: false,
          },
          {
            id: '2-3',
            title: 'E3',
            choose: false,
          },
          {
            id: '2-4',
            title: 'E4',
            choose: false,
          },
          {
            id: '2-5',
            title: 'E5',
            choose: false,
          },
          {
            id: '2-6',
            title: 'E6',
            choose: false,
          },
          {
            id: '2-7',
            title: 'E7',
            choose: false,
          },
          {
            id: '2-8',
            title: 'W1',
            choose: false,
          },
          {
            id: '2-9',
            title: 'W2',
            choose: false,
          },
          {
            id: '2-10',
            title: 'W3',
            choose: false,
          },
          {
            id: '2-11',
            title: 'W4',
            choose: false,
          },
          {
            id: '2-12',
            title: '室外A区',
            choose: false,
          },
        ],
      },
      returnDate: [],
      uploadForm: {
        page: '1',
        size: '100',
        value: {
          exhibitsType: [],
          hzBoothHall: [],
          keyword: '',
        },
      },
      allNum: 1,
      pageshow: true,
      currentPage4: 1,
      dialogVisible: false,
      newArrData: [],
      indexList: [],
    };
  },
  created() {
    document.documentElement.scrollTop = 0;
    window.scrollTo(0, 0);
    const language = localStorage.getItem('lang');
    this.lang = language;
    this.$i18n.locale = language == 'en' ? language : 'zh';

    if (language == 'en') {
      this.screenList = screenListEn;
    } else {
      this.screenList = screenList;
    }
    const href = window.location.href;
    if (this.$route.query.type) {
      // 筛选参数有type
      const arr = this.$route.query.type.split(',');
      arr.map((item) => {
        this.screenList.conditons.map((i) => {
          if (item === i.type) {
            i.choose = true;
            this.dynamicTags.push({ index: i.id, name: i.title, type: i.type });
          }
        });
      });
    }
    if (this.$route.query.screenHall) {
      // 筛选参数有hall
      const arr = this.$route.query.screenHall.split(',');
      arr.map((item) => {
        this.exhibitionList.conditons.map((i) => {
          if (item === i.title) {
            i.choose = true;
            this.dynamicTags.push({
              index: i.id,
              name: i.title + this.$t('common.hall'),
            });
          }
        });
      });
      const params = {
        page: 1,
        size: 100,
        value: {
          hzBoothHall: arr,
        },
      };
      this.getSearchHib(params);
    }

    if (this.$route.query.exhibitsType != null) {
      const arr = decodeURI(href).split('?');
      const newArr = arr[1].split('&');
      // 类型
      let type;
      if (newArr[0].includes('=')) {
        type = newArr[0].split('=');
        if (this.$route.query.exhibitsType == 0 || type[1] == '') {
          type = '';
        }
      } else {
        type = '';
      }

      let keyword;
      // 关键字
      if (newArr[1]) {
        keyword = newArr[1].split('=')[1];
      } else {
        keyword = '';
      }

      if (type != '') {
        const params = {
          page: 1,
          size: 100,
          value: {
            exhibitsType: type,
            keyword: keyword,
          },
        };
        this.getSearchHib(params);
      } else {
        const params = {
          page: 1,
          size: 100,
          value: {
            keyword: keyword,
          },
        };

        this.getSearchHib(params);
      }
    }
    const length = Object.keys(this.$route.query).length;
    if (length == 0 || this.$route.query.screenHall == '' || this.$route.query.type == '') {
      this.getexhDet();
    }
  },
  mounted() {},
  methods: {
    getMsgFormSon(data) {
      this.dialogVisible = data;
      tools.login(3);
    },
    getCancel(data) {
      this.dialogVisible = data;
    },
    async toggle(item) {
      const shouDetail = {
        objId: item.id,
        flag: !item.collectStatus,
        type: 1,
      };
      try {
        const data = await getShoucang(shouDetail);
        if (data.data.code === 200) {
          item.collectStatus = !item.collectStatus;
          if (item.collectStatus) {
            this.$message({
              showClose: true,
              message: this.$t('common.successCollect'),
              type: 'success',
            });
          } else {
            this.$message({
              showClose: true,
              message: this.$t('common.cancelCollect'),
              type: 'error',
            });
          }
        } else {
          // this.$message({
          //   showClose: true,
          //   message: data.data.msg,
          //   type: 'warning',
          // });
          // console.log(data);
          // tools.login(3);
        }
      } catch (err) {
        if (err == 'noLogin') {
          this.dialogVisible = true;
        }
        // console.log(err);
      }
    },
    consult(item) {
      const viewToken = localStorage.getItem('viewToken');
      const token = localStorage.getItem('token');
      if (!viewToken) {
        this.dialogVisible = true;
      }
      if (viewToken) {
        tools.login(1, item.id);
      }
      if (token && !viewToken) {
        this.$message({
          showClose: true,
          message: this.$t('message.isLimit'),
          type: 'error',
        });
        return;
      }
    },
    initVanIndexData(data) {
      // this.indexList = [];
      let arr = data;
      for (var i = 0; i < arr.length; i++) {
        arr[0]['addVanIndex'] = true;
        // this.indexList.push(arr[0].letter.toLocaleUpperCase());
        if (arr[i].letter !== arr[i + 1]?.letter) {
          if (arr[i + 1] !== undefined) {
            arr[i + 1]['addVanIndex'] = true;
            // this.indexList.push(arr[i + 1].letter.toLocaleUpperCase());
          }
        }
      }
      // this.indexList = Array.from(new Set(this.indexList));
      this.newArrData = arr;
      // console.log(Array.from(new Set(this.indexList)));
    },
    async getSearchHib(params) {
      const { data } = await mobileExhibits(params);
      this.allNum = data.data.count;
      //  console.log("从首页跳转到展商之后的查询",data);
      if (data.data.list.length > 0) {
        this.returnDate = data.data.list;
        this.initVanIndexData(this.returnDate);
      } else {
        this.returnDate = [];
      }
    },
    //   列表数据获取
    async getexhDet() {
      const data = await mobileExhibits(this.uploadForm);
      this.allNum = data.data.data.count;
      if (data.data.data.list.length > 0) {
        this.returnDate = data.data.data.list;
        this.initVanIndexData(this.returnDate);
      } else {
        this.returnDate = [];
      }
    },
    getElement(id) {
      return document.getElementById(id);
    },
    checkFirst(i) {
      this.deSelect(i);
    },

    checkSecond(item, first) {
      if (item.choose) {
        item.children.map((item) => {
          item.choose = true;
          this.dynamicTags.push({
            index: item.id,
            name: item.title,
            type: item.type,
            currentIndex: first.currentIndex,
          });
          this.dynamicTags = this.unique(this.dynamicTags);
        });
      } else {
        item.children.forEach((i) => {
          i.choose = false;
          const index = this.dynamicTags.findIndex((k) => {
            return i.title == k.name;
          });
          this.dynamicTags.splice(index, 1);

          this.dynamicTags = this.unique(this.dynamicTags);
        });
      }
    },
    unique(arr) {
      const res = new Map();
      return arr.filter((arr) => !res.has(arr.name) && res.set(arr.name, 1));
    },
    checkThird(arr, item, first) {
      if (item.choose) {
        this.dynamicTags.push({
          index: item.id,
          name: item.title,
          type: item.type,
          currentIndex: first.currentIndex,
        });

        const flag = arr.children.every((i) => {
          return i.choose == true;
        });
        flag ? (arr.choose = true) : console.log('');
      } else {
        const index = this.dynamicTags.findIndex((i) => {
          return i.name == item.title;
        });
        this.dynamicTags.splice(index, 1);
        const flag = arr.children.some((i) => {
          return i.choose == true;
        });
        flag ? (arr.choose = false) : console.log('');
      }
    },
    //取消选择
    deSelect(i) {
      if (i.choose) {
        i.title.length > 2
          ? this.dynamicTags.push({
              index: i.id,
              name: i.title,
              type: i.type,
              currentIndex: i.currentIndex,
            })
          : this.dynamicTags.push({
              index: i.id,
              name: i.title + this.$t('common.hall'),
            });
      } else {
        for (let item in this.dynamicTags) {
          i.id == this.dynamicTags[item].index ? this.dynamicTags.splice(item, 1) : console.log('失败');
        }
      }
    },
    checkEx(i) {
      this.deSelect(i);
    },
    handleClose(tag) {
      if (tag.index.length <= 3) {
        const val = tag.name == '室外A区'? tag.name:tag.name.substring(0, 2)
        this.matchTag(val, this.exhibitionList.conditons);
        this.tagDel(tag);
      } else {
        this.matchTag(tag.name, this.screenList.conditons);
        this.tagDel(tag);
        this.matchTree(tag.name, this.screenList.conditons[tag.currentIndex].children);
      }
    },
    //tags左侧匹配事件
    matchTag(val, arr) {
      for (let i = 0; i < arr.length; i++) {
        if (val == arr[i].title) {
          arr[i].choose = false;
          return false;
        }
      }
    },
    matchTree(tag, arr) {
      for (let i = 0; i < arr.length; i++) {
        arr[i].children.map((item) => {
          if (tag == item.title) {
            item.choose = false;
            arr[i].choose = false;
            return false;
          }
        });
      }
    },
    //tag标签删除
    tagDel(tag) {
      for (let item in this.dynamicTags) {
        if (this.dynamicTags[item].index == tag.index) {
          this.dynamicTags.splice(item, 1);
        }
      }
    },
    clearTag() {
      this.dynamicTags = [];
      //清空按产品类型筛选
      this.screenList.conditons.forEach((element) => {
        element.choose = false;
        element.children.forEach((i) => {
          i.choose = false;
          i.children.forEach((v) => {
            v.choose = false;
          });
        });
      });
      //清空按展馆筛选
      this.exhibitionList.conditons.forEach((element) => {
        element.choose = false;
      });
    },
    handleClose1() {
      this.selectvisible = false;
      // document.documentElement.style.overflowY = 'auto';
      const div = document.getElementsByTagName('body');
      div.style.overflow = 'auto';
    },
    handleClose2() {
      this.hallVisible = false;
      // document.documentElement.style.overflowY = 'auto';
    },
    submit() {
      this.selectvisible = false;
      window.scrollTo(0, 0);
    },
    submitHall() {
      this.hallVisible = false;
      window.scrollTo(0, 0);
    },
    handleChange() {},
    openPanel() {
      this.selectvisible = true;
      const div = document.getElementsByTagName('body');
      div.style.overflow = 'hidden';
    },
    openHallPanel() {
      this.hallVisible = true;
      // document.body.style.overflow = 'hidden';
    },
    goDetail(id) {
      this.$router.push({
        name: 'exhibition_det',
        query: {
          id,
        },
      });
    },
    searchClick() {
      // 点击搜索按钮进行搜索
      var exhibitsType = [];
      // console.log("tag数据",this.dynamicTags);
      if (this.dynamicTags.length > 0) {
        var exhibitsType = []; //产品标签
        var hzBoothHall = []; //展商标签
        this.dynamicTags.map((item) => {
          var reg = RegExp(/-/);
          var str = reg.test(item.index);
          if (str) {
            hzBoothHall.push(item.name == '室外A区'? item.name:item.name.substring(0, 2));
          } else {
            exhibitsType.push(item.type);
          }
        });
      }
      this.uploadForm = {
        page: '1',
        size: '100',
        value: {
          exhibitsType: exhibitsType,
          keyword: this.keyWords,
          hzBoothHall: hzBoothHall,
        },
      };
      this.getexhDet();
    },
    handleCurrentChange(val) {
      document.documentElement.scrollTop = 0;
      window.scrollTo(0, 0);
      if (this.dynamicTags.length > 0) {
        var exhibitsType = []; //产品标签
        var hzBoothHall = []; //展商标签
        this.dynamicTags.map((item) => {
          var reg = RegExp(/-/);
          var str = reg.test(item.index);
          if (str) {
            hzBoothHall.push(item.name == '室外A区'? item.name:item.name.substring(0, 2));
          } else {
            exhibitsType.push(item.type);
          }
        });
      }
      this.uploadForm = {
        page: val,
        size: '100',
        value: {
          exhibitsType: exhibitsType,
          keyword: this.keyWords,
          hzBoothHall: hzBoothHall,
        },
      };
      this.getexhDet();
    },
    scrollTo(index) {
      //  console.log(index, 666);
      let indexBar = this.$refs.indexBar;
      // for (var i = indexBar.$children.length - 1; i >= 0; i--) {
      //   var prevHeight = i > 0 ? rects[i - 1].height : 0;
      //   var reachTop = this.sticky ? prevHeight + this.stickyOffsetTop : 0;

      //   if (scrollTop + reachTop >= rects[i].top) {
      //     return i;
      //   }
      // }
      console.log(indexBar);
      // console.log(indexBar.getScrollerRect());
      // console.log(indexBar.scroller);

      var rects = indexBar.$children.map(function(item) {
        return item.getRect(indexBar.scroller, indexBar.getScrollerRect());
      });

      let scrollTop = indexBar.scroller.pageYOffset + 1;
      //console.log(indexBar.scroller);
      let barIndex = indexBar.getActiveAnchorIndex(scrollTop, rects);
      indexBar.activeAnchorIndex = null;
      indexBar.activeAnchorIndex = indexBar.$children[barIndex].index;
      //console.log(rects, scrollTop);
      //  console.log(indexBar.getActiveAnchorIndex(scrollTop, rects), '444');
      //  console.log(indexBar.activeAnchorIndex);
      // console.log(rects, '2222');
      // console.log(indexBar.scroller.pageYOffset, '333');
      // console.log(123);
      //indexBar.$el.childNodes[0].childNodes
      // indexBar.$el.childNodes[0].childNodes.map(el=>{

      // })
      // if (!this.loopChildChooseStatus(indexBar.$el.childNodes[0].childNodes)) {
      //   this.$set(indexBar.$el.childNodes[0].childNodes[0], 'className', 'van-index-bar__index van-index-bar__index--active');
      //   //  indexBar.$el.childNodes[0].childNodes[0].className = 'van-index-bar__index van-index-bar__index--active';
      //   indexBar.$el.childNodes[0].childNodes[0].classList.add('van-index-bar__index--active');
      // } else {
      //   indexBar.$el.childNodes[0].childNodes[0].className = 'van-index-bar__index';
      // }

      // console.log(indexBar.activeAnchorIndex);
    },
    loopChildChooseStatus(childNodes) {
      var that = this;
      console.log(childNodes);

      childNodes.forEach((el) => {
        that.$nextTick(function() {
          if (el.className.indexOf('van-index-bar__index--active') > -1) {
            console.log(el);
            console.log('存在选中');
            return true;
          }
        });
      });

      return false;
    },
  },
  watch: {
    keyWords(newValue, oldValue) {
      this.keyWords = newValue;
    },
    dynamicTags(newValue, oldValue) {
      var exhibitsType = []; //产品标签
      var hzBoothHall = []; //展商标签
      newValue.map((item) => {
        var reg = RegExp(/-/);
        var str = reg.test(item.index);
        if (str) {
          hzBoothHall.push(item.name == '室外A区'? item.name:item.name.substring(0, 2));
        } else {
          exhibitsType.push(item.type);
        }
      });
      this.uploadForm = {
        page: '1',
        size: '100',
        value: {
          exhibitsType: exhibitsType,
          keyword: this.keyWords,
          hzBoothHall: hzBoothHall,
        },
      };
      const hallKeywords = this.uploadForm.value.hzBoothHall;
      const type = this.uploadForm.value.exhibitsType;
      const strHall = hallKeywords.toString();
      const strType = type.toString();
      this.$router.push({
        query: { screenHall: strHall, type: strType },
      });
      this.currentPage4 = 1;
      this.pageshow = false;
      this.getexhDet();
      this.$nextTick(() => {
        this.pageshow = true;
      });
    },
    'uploadForm.value.hzBoothHall': {
      handler: function(newValue, oldValue) {
        if (oldValue.length !== 0) {
          if (newValue.length == 0) {
            const href = window.location.href;
            var arr = href.split('');
            const hallIndex = href.indexOf('screenHall=');
            if (hallIndex != -1) {
              if (arr[hallIndex - 1] === '?') {
                // hall在前
                arr.splice(hallIndex, 12);
              } else {
                arr.splice(hallIndex - 1, 12);
              }
            }
            const str = arr.join('');
            window.location.href = str;
          }
        }
      },
    },
    'uploadForm.value.exhibitsType': {
      handler: function(newValue, oldValue) {
        if (oldValue.length !== 0) {
          if (newValue.length == 0) {
            const href = window.location.href;
            var arr = href.split('');
            const typeIndex = href.indexOf('type=');
            if (typeIndex != -1) {
              if (arr[typeIndex - 1] === '?') {
                // type在前
                arr.splice(typeIndex, 6);
              } else {
                arr.splice(typeIndex - 1, 6);
              }
            }
            const str = arr.join('');
            window.location.href = str;
          }
        }
      },
    },
  },
};
</script>

<style scoped lang="scss">
.exhibitonScreen {
  .goldBox {
    width: 100%;
    margin-top: 4vw;
    padding-left: 4vw;
    padding-right: 4vw;
    box-sizing: border-box;

    .title {
      font-size: 4.8vw;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333;
      text-align: center;
      box-shadow: 0px 0px 6.8vw 0px #e8ecf0;
      padding: 4vw 0 3.3vw 0px;
      box-sizing: border-box;
      z-index: 20;
      color: #006fb8;
      background: #facd00;
    }

    //搜索框
    .search {
      padding: 0 2.6vw;
      padding-bottom: 5.3vw;
      box-sizing: border-box;
      height: 28.5vw;
      background: #facd00;
      .row1 {
        display: flex;
        .searchBox {
          width: 60vw;
        }

        //右侧的蓝色按钮
        .btn {
          width: 24vw;
          margin-left: 2.6vw;

          .el-button {
            width: 100%;
            background: #006fb8;
            font-size: 4.3vw;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            height: 9.6vw;
            line-height: 9.6vw;
            padding: 0;
            box-sizing: border-box;
            .el-icon-search:before {
              font-size: 3.3vw !important;
            }
          }
        }
      }
      .row2 {
        display: flex;
        margin-top: 4vw;
        .selecTree {
          width: 49vw;
          margin-right: 2.6vw;
          .inputSelect {
            width: 100%;
            -webkit-appearance: none;
            background-color: #fff;
            border-radius: 4px;
            border: 1px solid #dcdfe6;
            height: 9.6vw;
            line-height: 9.6vw;
            padding: 0 8vw 0 4vw;
            box-sizing: border-box;
            transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
            width: 100%;
            font-size: 3.7vw;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            position: relative;
            overflow: hidden;
            i {
              position: absolute;
              right: 0;
              top: 0;
              line-height: 9.6vw;
              height: 100%;
              width: 25px;
              text-align: center;
              transition: all 0.3s;
              line-height: 9.6vw;
            }
          }

          .el-select {
            width: 100%;
          }
        }
        .hall {
          width: 49vw;
          .inputSelect {
            width: 100%;
            -webkit-appearance: none;
            background-color: #fff;
            border-radius: 4px;
            border: 1px solid #dcdfe6;
            height: 9.6vw;
            line-height: 9.6vw;
            padding: 0 8vw 0 4vw;
            box-sizing: border-box;
            transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
            width: 100%;
            font-size: 3.7vw;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            position: relative;
            overflow: hidden;
            word-break: break-all;
            i {
              position: absolute;
              right: 0;
              top: 0;
              line-height: 9.6vw;
              height: 100%;
              width: 25px;
              text-align: center;
              transition: all 0.3s;
              line-height: 9.6vw;
            }
          }
        }
      }

      //右边的输入框以及按钮
    }
  }
  .productLists {
    .bottom {
      width: 100%;
      height: 15%;
      background: #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(109, 109, 109, 0.35);
      position: relative;
      padding-right: 6.4vw;
      box-sizing: border-box;
      // margin-top: 7vw;
      .btn {
        width: 24vw;
        height: 9.6vw;
        background: #006fb8;
        border-radius: 1vw;
        line-height: 9.6vw;
        text-align: center;
        font-size: 4.2vw;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        float: right;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }

  .screenTag {
    margin-top: 7.2vw;
    padding-left: 4vw;
    padding-right: 4vw;
    box-sizing: border-box;
    .selectt {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      .text {
        margin-bottom: 2.5vw;
      }
      .el-button--primary {
        border-radius: 0.5vw;
        text-align: center;
        width: 16.9vw;
        height: 7.7vw;
        background: #006fb8;
        border-radius: 1vw;
        line-height: 7.7vw;
        text-align: center;
        font-size: 4.2vw;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        padding: 0;
        box-sizing: border-box;
        font-size: 3.2vw;
        font-family: Microsoft YaHei;
      }
      .disp {
        margin-left: 1.3vw;
      }
      .clear {
        margin-left: 1.3vw;
        button {
          // margin-bottom: 1.2vw;
        }
      }
    }
  }
  .exhibitionList {
    margin-top: 20px;
    width: 100%;
    position: relative;

    .screenCondition {
      width: 100%;
      background-color: white;
      // float: left;
      height: 70%;

      ul {
        padding-bottom: 10px;
        box-sizing: border-box;
        width: 95%;
      }
      li {
        padding: 0;
        margin: 0;
        width: 81px;
        list-style: none;
        .el-checkbox {
          margin-left: 30px;
          line-height: 40px;
          height: 40px;
        }
      }
      ul li:hover .secondCategory {
        display: block;
      }
    }
    .bottom {
      width: 100%;
      height: 30%;
      background: #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(109, 109, 109, 0.35);
      position: relative;
      padding-right: 6.4vw;
      box-sizing: border-box;
      .btn {
        width: 24vw;
        height: 9.6vw;
        background: #006fb8;
        border-radius: 1vw;
        line-height: 9.6vw;
        text-align: center;
        font-size: 4.2vw;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        float: right;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
  .rightContent {
    padding-left: 4vw;
    box-sizing: border-box;
    .content {
      margin-bottom: 4vw;
      width: 41.4vw;
      height: 55.1vw;
      background-color: #ffffff;
      border: 1px solid #e0e0e0;
      box-shadow: 0px 0px 6.8vw 0px #e8ecf0;
      position: relative;
      margin-right: 4vw;
      .vedio1 {
        .top {
          width: 100%;
          height: 13.3vw;
        }
        .fixed {
          width: 100%;
          height: 77%;
          position: absolute;
          top: 0;
          background-color: rgba(30, 30, 30, 0.3);
          display: none;
          z-index: 1;
          img {
            margin: 11.7vw 16.4vw;
          }
        }
        .main {
          width: 100%;
          height: 30.4vw;
          background-color: rgba(76, 179, 254, 0.11);
          padding-top: 10.67vw;
          box-sizing: border-box;
          text-align: center;
          font-size: 1.87vw;
          font-family: Microsoft YaHei;
          font-weight: 400;

          span {
            margin-top: 1.73vw;
            color: #333;
            font-size: 3.2vw;
          }
          .company {
            font-size: 3.7vw;
            font-family: Microsoft YaHei;
            font-weight: 800;
            color: #333333 !important;
            margin: 0 auto;
            word-break: break-all;
            width: 37.1vw;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            height: 10.5vw;
          }
          .number {
            display: inline-block;
            /*   color: #fdd000; */
            color: #333333;
            font-weight: 600;
            margin-top: 1.73vw;
            margin-left: 1.3vw;
            font-size: 3.7vw;
          }
        }
        .titleLogo {
          width: 29.9vw;
          height: 16vw;
          background: #ffffff;
          box-shadow: 0px 0px 6.8vw 0px #e8ecf0;
          position: absolute;
          top: 5.3vw;
          left: 6vw;
          padding: 0 2vw;
          box-sizing: border-box;
          text-align: center;
          line-height: 14.53vw;
          align-items: center;

          img {
            max-width: 100%;
            max-height: 100%;
            vertical-align: middle;
          }
        }
      }
      .bottom::after {
        content: '';
        display: block;
        height: 0;
        visibility: hidden;
        clear: both;
      }
      .bottom {
        padding-top: 2.1vw;
        padding-left: 3.2vw;
        padding-right: 3.2vw;
        box-sizing: border-box;
        width: 100%;
        .bottomLeft,
        .bottomRight {
          margin-top: 1.3vw;
          box-sizing: border-box;
          float: left;
          font-size: 3.2vw;
          cursor: pointer;
          color: #006fb8;
          font-family: Microsoft YaHei;
          font-weight: 400;
          text-align: center;
        }
        .bottomLeft {
          border-right: 1px solid #ccc;
          width: 50%;
        }
        .bottomRight {
          width: 50%;
          float: right;
          display: flex;
          overflow: hidden;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          // width: 18vw;
        }
      }
    }
    // .vedio1:hover > .fixed {
    //   display: block;
    // }
  }
  .pagination {
    display: flex;
    justify-content: center;
    margin: 2.6vw 0 8vw;
    span {
      font-size: 1.6vw;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      margin-top: 1.2vw;
    }
  }
}
</style>
<style scoped lang="scss">
.el-dialog {
  text-align: center;
}
::v-deep .explore_right_pages {
  display: flex;
  align-items: center;
  justify-content: center;
  .el-pagination button:hover {
    color: #978d8d;
  }
  .el-pagination button {
    color: #999999;
  }

  .el-pager li {
    background-color: unset;
    vertical-align: middle;
    min-width: 5.3vw;
    padding: 0;
    box-sizing: border-box;
  }
  .el-pager li:hover {
    color: #999999;
  }
  .btn-prev {
    width: 5.3vw;
    height: 5.3vw;
    line-height: 5.3vw;
    color: #333;
    font-size: 2.1vw;
    background: #fff;
    border-radius: 0.5vw;
    border: 1px solid #cccccc;
    padding-left: 0;
    padding-right: 0;
    margin-right: 0.7vw;
    margin-left: 1.3vw;
  }

  .btn-next {
    width: 5.3vw;
    height: 5.3vw;
    line-height: 5.3vw;
    color: #333;
    font-size: 2.1vw;
    background: #fff;
    border-radius: 4px;
    border: 1px solid #cccccc;
    padding-left: 0;
    padding-right: 0;
    margin-right: 0.7vw;
  }
  .el-pager .number {
    width: 5.3vw;
    height: 5.3vw;
    line-height: 5.3vw !important;
    border-radius: 0.5vw;
    border: 1px solid #cccccc;
    margin-right: 1vw;
    color: #333;
    font-size: 2.1vw;
    font-family: Microsoft YaHei;
    font-weight: 400;
    background: #fff;
  }
  .el-pager .number:hover {
    color: #006fb8;
  }
  .el-pager li.active {
    width: 5.3vw;
    height: 5.3vw;
    line-height: 5.3vw !important;
    border: 1px solid #007cc2;
    cursor: pointer;
    background: #006fb8;
    font-size: 2.1vw;
    font-weight: 400;
    color: #fff;
    font-family: Microsoft YaHei;
  }
  .el-pager li.active:hover {
    color: #fff;
    background: #006fb8;
  }
  .el-pager li.btn-quicknext {
    line-height: 3.7vw;
    color: #999;
  }
}
</style>
<style scoped>
.el-tag {
  margin-left: 2.6vw !important;
  margin-top: 1vw;
  margin-bottom: 1.6vw !important;
  height: 7.7vw !important;
  line-height: 7.7vw !important;
}
.el-dialog__wrapper >>> .el-dialog__footer {
  text-align: center;
}
.dialog-footer >>> .el-button--primary {
  width: 28.8vw;
  height: 9.6vw;
  background: #006fb8;
  border-radius: 1vw;
}
.el-dialog__wrapper >>> .el-dialog {
  width: 66.67vw !important;
  /* height: 75.47vw; */
  background: #ffffff;
}
>>> .el-dialog__headerbtn {
  color: #312c2b;
  font-size: 2.93vw;
}
</style>
<style scoped>
.el-drawer__wrapper >>> .el-drawer {
  height: 70% !important;
  /* position: fixed;
  -webkit-transform: translateZ(0);
  transform: translateZ(0); */
}
.el-drawer__wrapper >>> .el-drawer__body {
  height: 85%;
}
.el-tabs--left >>> .el-tabs__item.is-left {
  text-align: left;
  max-height: 10vw;
  font-size: 3.2vw;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  width: 100%;
  margin-top: 3vw;
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
  white-space: pre-wrap;
  flex-direction: column;
  justify-content: center;
  display: flex;
}
.el-tabs >>> .el-tabs__nav-prev {
  display: none;
}
.el-tabs >>> .el-tabs__nav-next {
  display: none;
}
.el-tabs--left >>> .el-tabs__nav-scroll {
  overflow: scroll !important;
  /* overflow-y: hidden !important; */
  height: 100% !important;
}
/* .el-drawer__wrapper >>> span {
  width: 100%;
  white-space: normal;
} */
.el-tabs--left >>> .el-tabs__nav-wrap.is-left.is-scrollable {
  padding-top: 4vw;
  padding-bottom: 4vw;
  box-sizing: border-box;
}
.el-tabs--left >>> .el-tabs__nav-wrap.is-left::after {
  width: 1px;
  margin-right: 0px;
}
>>> .el-tabs__item.is-active {
  background: #f4f4f4 !important;
  color: #006fb8 !important;
}
.el-tabs >>> .el-tabs__header {
  width: 39.2%;
  margin: 0;
}
.el-tabs >>> .el-tabs__content {
  padding-top: 5.3vw;
  padding-bottom: 5.3vw;
  box-sizing: border-box;
  height: 100%;
}
.el-tabs {
  height: 85%;
  padding-bottom: 8vw;
  box-sizing: border-box;
}
.el-drawer__wrapper >>> .el-tabs__active-bar {
  background-color: transparent !important;
}
.el-collapse {
  border-top: 0px;
}
.el-checkbox >>> .el-checkbox__label {
  white-space: normal;
  vertical-align: text-top;
  width: 60px;
}
.el-tabs__item .el-checkbox >>> .el-checkbox__label {
  font-size: 3.2vw;
}
.el-collapse-item .el-collapse-item__header .el-checkbox >>> .el-checkbox__label {
  font-size: 3.7vw;
}
.el-collapse-item__content .el-checkbox >>> .el-checkbox__label {
  font-size: 3.2vw;
}
.el-radio >>> .el-radio__label {
  white-space: normal;
  vertical-align: text-top;
  display: inline-block;
  padding-left: 1.3vw;
  font-size: 1.87vw;
  /* overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; */
}
.el-collapse-item >>> .el-collapse-item__wrap {
  background: #f6f6f7;
  overflow-y: scroll !important;
  /* max-height: 62vw; */
}
.el-collapse-item >>> .el-checkbox,
.el-radio {
  height: 8vw;
  line-height: 4vw;
  font-size: 3.2vw;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-top: 2vw;
  display: block;
}
.el-collapse-item >>> .el-collapse-item__content {
  padding-bottom: 0px;
  padding: 0px 4vw;
  box-sizing: border-box;
  width: 100%;
}
.el-collapse-item >>> .el-collapse-item__header {
  padding: 0px 4vw;
  box-sizing: border-box;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 3.7vw;
  font-family: Microsoft YaHei;
  font-weight: bold;
}

.exhibitionList .el-drawer__wrapper >>> .el-drawer {
  height: 35% !important;
}
.boxImg {
  margin: 0 auto;
  text-align: center;
  font-size: 1.87vw;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}

.boxImg img {
  width: 50.67vw;
  height: 40vw;
}
.el-divider--vertical {
  margin: 0 auto;
}
.el-pagination >>> button {
  min-width: 5.3vw;
}
.pagination >>> .el-icon-arrow-right,
.pagination >>> .el-icon-arrow-left {
  color: #333;
}
.el-collapse-item >>> .el-collapse-item__header .el-checkbox__label {
  width: 40vw;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}
.el-tabs--left >>> .el-tabs__item.is-left .el-checkbox__label {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.el-tabs--left >>> .el-tabs__item.is-left .el-checkbox {
  display: flex;
}
.el-collapse-item >>> .el-collapse-item__content .el-checkbox__label {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  height: 8.5vw;
  line-height: 4.5vw;
}
.el-collapse-item >>> .el-collapse-item__content .el-checkbox {
  display: flex;
}
.el-collapse-item >>> .el-collapse-item__content {
  max-height: 60vw;
  overflow-y: auto;
  padding-bottom: 4vw;
  padding-top: 4vw;
  box-sizing: border-box;
}
.searchBox >>> .el-input__inner {
  height: 9.6vw;
  line-height: 9.6vw;
  font-size: 3.7vw;
}
>>> .el-checkbox__inner {
  vertical-align: middle;
}
.van-index-bar >>> .van-index-anchor {
  padding: 0;
  box-sizing: border-box;
}
.van-hairline--bottom::after {
  border: 0;
}
.van-index-bar >>> .van-index-anchor {
  display: none;
}
.rightContent >>> .van-index-bar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.van-index-bar >>> .van-index-bar__sidebar {
 
}
.van-index-bar >>> .van-index-bar__index {
  font-size: 4vw;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #333333;
  line-height: 4.3vw;
  padding: 0;
  padding-right: 1.73vw;
  box-sizing: border-box;
}
.van-index-bar >>> .van-index-bar__index--active {
  color: #ee0a24;
}
>>> .el-checkbox__input{
  line-height: inherit;
}
</style>
